
import type { PropType } from 'vue'
import type { Action } from '../shared/epb-pill'

import { defineComponent } from 'vue'

import { ColorEnum, KeyboardCodeEnum } from '../../enums'
import { UiTextbox } from '../keen-ui'
import { EpbButton } from '../shared/epb-button'
import { EpbPill } from '../shared/epb-pill'
import InputErrors from './input-errors.component.vue'
import InputLabel from './input-label.component.vue'

export default defineComponent({
  name: 'StringArrayInput',
  components: {
    EpbButton,
    EpbPill,
    InputErrors,
    InputLabel,
    UiTextbox,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    showDescriptionAsBadge: {
      type: Boolean,
    },
    value: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    required: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    errors: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    itemErrors: {
      type: Object as PropType<Record<string, Array<string>>>,
      default: () => ({}),
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
    },
    separator: {
      type: String,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      baseClass: 'epb-string-array-input',
      newValueItem: '',
    }
  },
  methods: {
    onInputKeydown(event: KeyboardEvent): void {
      if (event.key === KeyboardCodeEnum.ENTER) {
        this.addValueItem()
        event.preventDefault()
      }
    },
    addValueItem(): void {
      const newValueItems = this.separator
        ? this.newValueItem.split(this.separator)
        : [this.newValueItem]
      const value = newValueItems.reduce((result: string[], newValueItem: string) => {
        const trimmedValueItem = newValueItem.trim()
        if (!!trimmedValueItem && !result.includes(trimmedValueItem)) {
          result.push(newValueItem)
        }
        return result
      }, this.value.slice())
      if (value.length === this.value.length) {
        return
      }
      this.$emit('input', value)
      this.newValueItem = ''
    },
    removeValueItem(valueIndex: number): void {
      const newValue = [...this.value]
      newValue.splice(valueIndex, 1)
      this.$emit('input', newValue)
    },
    getPillProps(
      valueItem: string,
      valueIndex: number,
    ): {
      label: string
      color?: ColorEnum
      tooltip?: string
      actions?: Action[]
    } {
      const valueErrors = this.itemErrors[valueIndex]
      return {
        label: valueItem,
        ...(!!valueErrors?.length && {
          color: ColorEnum.ERROR,
          tooltip: valueErrors[0],
        }),
        ...(!this.readOnly && {
          actions: [
            {
              id: 'close',
              icon: 'close',
            },
          ],
        }),
      }
    },
  },
})
